import React, { PropTypes } from 'react'
import classnames from 'classnames'

import VisuallyHidden from 'components/VisuallyHidden'

import styles from './ButtonIcon.scss'

const ButtonIcon = ({ children, className, label, onClick, ...rest }) => (
  <button
    className={classnames([styles.base], className)}
    onClick={onClick}
    {...rest}
  >
    <VisuallyHidden>{label}</VisuallyHidden>
    {children}
  </button>
)


ButtonIcon.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

export default ButtonIcon



// WEBPACK FOOTER //
// ./src/components/ButtonIcon/ButtonIcon.js